import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import type { TypePostThirdPartySkuExcelDownloadParams } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/third-parties/third-party-sku-excel-download';

/**
 * [상품관리][상품 등록/수정] 상품 엑셀 다운로드 API
 */
export const fetchPostThirdPartySkuExcelDownload = async (params: TypePostThirdPartySkuExcelDownloadParams) => {
  const response = await axiosInstance.post<Blob>(ENDPOINT, null, { params, responseType: 'blob' });
  downloadBlobDataFile(response);
};

/**
 * [상품관리][상품 등록/수정] 상품 엑셀 다운로드 Mutation Hook
 */
export const usePostThirdPartySkuExcelDownloadMutation = () => {
  return useDownloadMutation(fetchPostThirdPartySkuExcelDownload);
};
